<template>
  <div>
    <base-header class="pb-1">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0"></h6>
        </div>
      </div>
    </base-header>
  
    <div class="container-fluid mt--6">
      <form @submit.prevent>
        <div class="col-md-12">
          <card>
            <h3 slot="header" class="mb-0">Corretores</h3>
            <div class="row">
              <div class="col-md-10">
                <div class="form-group">
                  <label>Filtro</label>
                  <input type="text" class="form-control" v-model="name" placeholder="Nome" @keyup.enter="loadBroker" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group mb-0">
                  <label>Ativo?</label>
                  <div class="d-flex align-items-center" style="height: 41px;">
                    <el-switch v-model="enabled" active-color="#2C4759" />
                  </div>
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <base-button type="primary" @click="loadBroker">Buscar</base-button>
                <base-button type="secondary" @click="clear">Limpar</base-button>
              </div>
            </div>
            <div class="col-md-12 text-right mb-3">
              <base-button type="neutral" icon size="sm" @click="newBroker">
                <span class="btn-inner--icon"><i class="fas fa-wallet"></i></span>
                <span class="btn-inner--text">Novo Corretor</span>
              </base-button>
            </div>
            <table class="table">
              <thead class="thead">
                <tr>
                  <th scope="col" width="100">#</th>
                  <th scope="col">Nome</th>
                  <th scope="col" width="100"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="broker in brokers" :key="broker.id">
                  <td>{{broker.id}}
                  </td>
                  <td><a href="javascript:void(0);" @click.prevent="open(broker.id)">{{broker.name}}</a>
                  </td>
                  <td>
                    <a href="#" title="Alterar Corretor" @click="open(broker.id)"><i class="far fa-folder-open"></i></a>
                    <a href="#" title="Excluir Corretor" @click.prevent="deleteBroker(broker.id)" class="ml-2"><i
                        class="fas fa-trash-alt"></i></a>
                  </td>
                </tr>
                <tr v-show="brokers.length == 0">
                  <td colspan="8">
                    <center>Nenhum corretor disponível.</center>
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </form>
    </div> <!--- fecha conteudo -->
  </div>
</template>

<script>
import { Switch } from 'element-ui';

export default {
  components: {
    [Switch.name]: Switch,
  },
  mounted() {
    this.loadBroker();
  },
  data() {
    return {
      name: '',
      enabled: true,
      brokers: []
    };
  },
  methods: {
    loadBroker() {
      const params = {
        enabled: this.enabled
      };

      if (this.name)
        params.name = this.name;

      this.$clubApi.get('/broker', { params })
        .then(response => this.brokers = response.data.object)
        .catch(this.error)
        .finally(this.done);
    },
    clear() {
      this.name = '';
      this.enabled = true;
      this.loadBroker();
    },
    open(id) {
      location.href = '/configuracoes/corretor/editar/' + id;
    },
    newBroker() {
      location.href = '/configuracoes/corretor/novo';
    },
    deleteBroker(id) {
      this.$clubApi.delete(`/broker/${id}`)
        .then(() => this.loadBroker())
        .catch(this.error)
        .finally(this.done);
    },
    done() {
      NProgress.done();
    },
    error(error) {
      this.$notify({ type: 'warning', message: error.response.data.msg });
    }
  }
}
</script>